import React from "react";
import Dialog from "../../../../shared/dialog";
import moment from "moment";
import "moment/locale/ja";
import MomentUtils from "@date-io/moment"; // choose your lib
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { schemaPercentage, schemaFixed, schemaDate } from "../validate";
import cloneDeep from "lodash/cloneDeep";
import MyButton from "./../../../../shared/buttons/primary";
import CustomDatePicker from "../../../../shared/form-datepicker";
import {
  CITY_BOOKING,
  MENU_TYPE_ALL,
  MENU_TYPE_INDIVIDUAL,
  GOURMET,
} from "../../../../../constants/app";

moment.locale("ja");

class DiscountDialog extends React.Component {
  constructor(props) {
    super(props);
    const user = window.store.getState().auth.user;
    const block_time = user.booking_time_block;
    const isCityBooking = user.city_name === CITY_BOOKING;
    const isGourmet = user.category_type === GOURMET;
    this.isGourmet = isGourmet;
    this.isCityBooking = isCityBooking;
    this.booking_block_time = block_time;
    this.state = {
      isBtnDisabled: false,
      errorMessages: [],
      discountData: {
        name: "",
        value: "",
        code: "",
        type: "Fixed",
        value_other: "",
        menu_type: isCityBooking ? MENU_TYPE_INDIVIDUAL : "",
        valid_from: props.defaultTimeByWorkingHour.startTime,
        valid_to: props.defaultTimeByWorkingHour.endTime,
        shop: user.id,
      },
    };
  }

  componentDidMount() {
    const data = window._.cloneDeep(this.props.data);
    if (data.value) {
      data.value = data.value.toString().split(".")[0];
    }

    if (data.type === "Other") {
      data.type = "Fixed";
    }

    this.setState((prev) => ({
      ...prev,
      discountData: {
        ...prev.discountData,
        ...data,
      },
    }));
  }

  addScrollEvent = (node) => {
    this.addScrollEvent = function () {};

    node.addEventListener("scroll", () => {
      document.activeElement.blur();
    });
  };

  componentDidUpdate() {
    const discountDialogNode = document.querySelector("#edit-discount-dialog");
    if (window.store.getState().booking.isMobile && discountDialogNode) {
      this.addScrollEvent(discountDialogNode);
    }
  }

  validateOnBlur = (e) => {
    let errorList;
    const {
      error: { details },
    } =
      this.state.discountData.type === "Fixed"
        ? schemaFixed.validate({
            [e.target.name]: e.target.value,
          })
        : schemaPercentage.validate({
            [e.target.name]: e.target.value,
          });
    errorList = details;

    let errorMsgState = this.state.errorMessages;
    const error = errorList.find(
      (item) => item.context.label === e.target.name
    );

    if (!error) {
      const errorIdx = errorMsgState.findIndex(
        (error) => error.name === e.target.name
      );
      if (errorIdx !== -1) {
        errorMsgState.splice(errorIdx, 1);
      }
    } else {
      const item = errorMsgState.find(
        (item) => item.name === error.context.label
      );

      if (!item) {
        errorMsgState.push({
          name: e.target.name,
          message: error.message,
        });
      } else {
        errorMsgState = errorMsgState.map((item) => {
          if (item.name === error.context.label) {
            return {
              name: e.target.name,
              message: error.message,
            };
          }

          return item;
        });
      }
    }

    if (e.target.name === "value" && e.target.value) {
      errorMsgState = errorMsgState.filter(
        (item) => item.name !== "value_other"
      );
    }

    if (e.target.name === "value_other" && e.target.value) {
      errorMsgState = errorMsgState.filter((item) => item.name !== "value");
    }

    this.setState((prev) => ({
      ...prev,
      errorMessages: errorMsgState,
    }));
  };

  handleStartTimeChange = (date) => {
    if (moment(date).isAfter(moment(this.state.discountData.valid_to))) {
      this.setState((prevState) => ({
        ...prevState,
        discountData: {
          ...prevState.discountData,
          valid_to: moment(
            this.isCityBooking
              ? moment(date).add(this.booking_block_time, "minutes")
              : date,
            moment.ISO_8601
          ).format(),
        },
      }));
    }

    this.setState((prevState) => ({
      ...prevState,
      discountData: {
        ...prevState.discountData,
        valid_from: moment(date, moment.ISO_8601).format(),
      },
    }));
  };

  handleEndTimeChange = (date) => {
    const { error } = schemaDate.validate({
      valid_from: moment(this.state.discountData.valid_from).toDate(),
      valid_to: moment(date).toDate(),
    });

    if (error) {
      let errMessages = this.state.errorMessages;
      let index = errMessages.findIndex((err) => err.name === "valid_to");

      if (index === -1) {
        errMessages.push({
          name: "valid_to",
          message: error.details[0].message,
        });
      }
      this.setState((prev) => ({
        ...prev,
        errorMessages: errMessages,
      }));
    } else {
      let errMessages = this.state.errorMessages;
      let index = errMessages.findIndex((err) => err.name === "valid_to");
      if (index !== -1) {
        errMessages.splice(index, 1);
      }
      this.setState((prev) => ({
        ...prev,
        errorMessages: errMessages,
      }));
    }

    this.setState((prevState) => ({
      ...prevState,
      discountData: {
        ...prevState.discountData,
        valid_to: moment(date, moment.ISO_8601).format(),
      },
    }));
  };

  onCloseRequest = (data) => {
    this.props.onCloseRequest(data);
  };
  editMenu = async () => {
    await this.setState({ isBtnDisabled: true });

    const { discountData } = this.state;

    const validate =
      discountData.type === "Fixed"
        ? schemaFixed.validate(discountData)
        : schemaPercentage.validate(discountData);

    let validateLabels = ["name", "valid_to"];
    if (this.isCityBooking) {
      if (!discountData.value && !discountData.value_other) {
        validateLabels = [...validateLabels, "value", "other_value"];
      }
    } else {
      validateLabels.push("value");
    }

    let errors;
    errors = validate.error.details.filter((item) =>
      validateLabels.includes(item.context.label)
    );

    errors = errors.map((item) => {
      return {
        name: item.context.label,
        message: item.message,
      };
    });

    if (errors.length) {
      this.setState((prev) => ({
        ...prev,
        errorMessages: errors,
      }));

      this.setState({ isBtnDisabled: false });
      return;
    }

    const submitData = cloneDeep(this.state.discountData);

    submitData.valid_from = moment(submitData.valid_from).format(
      "YYYY-MM-DD HH:mm"
    );
    submitData.valid_to = moment(submitData.valid_to).format(
      "YYYY-MM-DD HH:mm"
    );

    if (this.isCityBooking) {
      if (submitData.value_other) {
        submitData.type = null;
        submitData.value = null;
      }

      if (submitData.value && submitData.type) {
        submitData.value_other = null;
      }
    }

    window
      .axios({
        url: `discount/${this.state.discountData.id}/`,
        method: "put",
        data: submitData,
      })
      .then((result) => {
        this.props.onCloseRequest(result.data);
      })
      .catch((err) => {
        const error = err.response.data.error;
        if (error) {
          const key = Object.keys(error);
          let errorMessages = key.map((item) => ({
            message: error[item]?.[0] || error[item],
            name: item,
          }));
          this.setState((prev) => ({
            ...prev,
            errorMessages,
            isBtnDisabled: false,
          }));
        }
      });
  };

  disabledEndTime = (date) => {
    const startTime = moment(this.state.discountData.valid_from).format(
      "YYYY-MM-DD"
    );
    const endTime = moment(date).format("YYYY-MM-DD");
    return moment(endTime).isBefore(moment(startTime));
  };

  onUnitChange = (e) => {
    this.setState((prev) => {
      return {
        ...prev,
        discountData: {
          ...prev.discountData,
          type: e.target.value,
        },
      };
    });
  };

  render() {
    const { validateOnBlur, props, onCloseRequest, editMenu, onUnitChange } =
      this;
    const { discountData, errorMessages } = this.state;
    const minDate = discountData.valid_from
      ? new Date(discountData.valid_from)
      : new Date();
    return (
      <Dialog
        id="edit-discount-dialog"
        className={"booking-dialog menu-dialog"}
        title={"割引編集"}
        isShow={props.isShow}
        onCloseRequest={() => onCloseRequest({})}
        closeOnOverlayClick={false}
      >
        <div className="booking-form__row required">
          <div className="booking-form__label">
            <label className="form-label user-select-none">割引名</label>
          </div>
          <div className="booking-form__control">
            <input
              className="form-control"
              placeholder="割引名"
              value={discountData.name}
              name="name"
              maxLength="255"
              autoFocus
              onBlur={validateOnBlur}
              onChange={(e) => {
                this.setState((prev) => {
                  return {
                    ...prev,
                    discountData: {
                      ...prev.discountData,
                      name: !e.target.value.trim() ? "" : e.target.value,
                    },
                  };
                });
              }}
            />
            {errorMessages.find((item) => item.name === "name") && (
              <p className="error-text">
                {errorMessages.find((item) => item.name === "name").message}
              </p>
            )}
          </div>
        </div>
        {this.isCityBooking && (
          <div className="booking-form__row required">
            <div className="booking-form__label">
              <label className="form-label user-select-none">割引種別</label>
            </div>
            <div className="booking-form__control">
              <div className="booking-form__type">
                <div className="d-flex items-center">
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={discountData.menu_type === MENU_TYPE_INDIVIDUAL}
                      id="flexRadioDefault1"
                      onChange={(e) => {
                        const { value } = e.target;
                        if (value) {
                          this.setState((prev) => {
                            return {
                              ...prev,
                              discountData: {
                                ...prev.discountData,
                                menu_type: MENU_TYPE_INDIVIDUAL,
                              },
                            };
                          });
                        }
                      }}
                    />
                    <label
                      className="form-check-label align-middle"
                      htmlFor="flexRadioDefault1"
                    >
                      {`${this.isGourmet ? "コース" : "メニュー"}`}毎の設定
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="flexRadioDefault2"
                      checked={discountData.menu_type === MENU_TYPE_ALL}
                      onChange={(e) => {
                        const { value } = e.target;
                        if (value) {
                          this.setState((prev) => {
                            return {
                              ...prev,
                              discountData: {
                                ...prev.discountData,
                                menu_type: MENU_TYPE_ALL,
                              },
                            };
                          });
                        }
                      }}
                    />
                    <label
                      className="form-check-label align-middle"
                      htmlFor="flexRadioDefault2"
                    >
                      時間枠一括設定
                    </label>
                  </div>
                </div>
              </div>
              {errorMessages.find((item) => item.name === "type") && (
                <p className="error-text">
                  {errorMessages.find((item) => item.name === "type").message}
                </p>
              )}
            </div>
          </div>
        )}
        <div className="booking-form__row required">
          <div className="booking-form__label">
            <label className="form-label user-select-none">割引価格</label>
          </div>
          <div className="booking-form__control">
            <div className="form-time">
              <input
                inputMode="decimal"
                className="form-control me-2"
                placeholder="割引価格"
                value={discountData.value}
                disabled={!!discountData.value_other && this.isCityBooking}
                maxLength="15"
                onInput={(e) => {
                  if (discountData.type === "Fixed") {
                    if (+e.target.value < 1) {
                      e.target.value = "";
                    }
                  }
                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                }}
                name="value"
                onBlur={validateOnBlur}
                onChange={(e) =>
                  this.setState((prev) => {
                    return {
                      ...prev,
                      discountData: {
                        ...prev.discountData,
                        value: e.target.value,
                      },
                    };
                  })
                }
              />
              <select
                className="form-select"
                onChange={onUnitChange}
                value={discountData.type}
                disabled={!!discountData.value_other}
              >
                <option value="Percentage">%</option>
                <option value="Fixed">円</option>
              </select>
            </div>
            {this.isCityBooking && (
              <div className="form-time mt-2">
                <input
                  inputMode="decimal"
                  className="form-control me-2"
                  placeholder="割引内容を入力"
                  value={discountData.value_other}
                  maxLength="50"
                  name="value_other"
                  disabled={!!(discountData.value && discountData.type)}
                  onBlur={validateOnBlur}
                  onChange={(e) =>
                    this.setState((prev) => {
                      return {
                        ...prev,
                        discountData: {
                          ...prev.discountData,
                          value_other: e.target.value,
                        },
                      };
                    })
                  }
                />
              </div>
            )}
            {discountData.value && discountData.type === "Fixed" ? (
              <p style={{ fontSize: "14px", marginTop: "8px" }}>
                ￥{Number(discountData.value).format(0, 3, ",", ".")}
              </p>
            ) : (
              ""
            )}
            {errorMessages.find((item) => item.name === "value") && (
              <p className="error-text">
                {errorMessages.find((item) => item.name === "value").message}
              </p>
            )}
          </div>
        </div>
        <div className="mb-3 booking-form__row required">
          <div className="booking-form__label">
            <label
              htmlFor="customerTime"
              className="form-label user-select-none"
            >
              時間
            </label>
          </div>
          {this.isCityBooking ? (
            <div className="booking-form__control">
              <div className="date-time-wrapper">
                <div className="start-date">
                  <CustomDatePicker
                    className="form-control"
                    onChange={this.handleStartTimeChange}
                    option={{
                      selectedDate: moment(discountData.valid_from).toDate(),
                    }}
                    name="created_date_to"
                    showTimeSelect
                    timeIntervals={this.booking_block_time}
                    dateFormat="M月d日 hh:mm a"
                    minDate={new Date()}
                    showTimeByWorkingTime
                  />
                </div>
                <span>~</span>
                <div className="end-date">
                  <CustomDatePicker
                    className="form-control"
                    onChange={this.handleEndTimeChange}
                    name="created_date_to"
                    option={{
                      selectedDate: moment(discountData.valid_to).toDate(),
                    }}
                    showTimeSelect
                    timeIntervals={this.booking_block_time}
                    dateFormat="M月d日 hh:mm a"
                    minDate={minDate}
                    showTimeByWorkingTime
                  />
                </div>
              </div>
              {errorMessages.find((item) => item.name === "valid_to") && (
                <p className="error-text">
                  {
                    errorMessages.find((item) => item.name === "valid_to")
                      .message
                  }
                </p>
              )}
              {errorMessages.find((item) => item.name === "valid_from") && (
                <p className="error-text">
                  {
                    errorMessages.find((item) => item.name === "valid_from")
                      .message
                  }
                </p>
              )}
            </div>
          ) : (
            <div className="booking-form__control">
              <div className="date-time-wrapper">
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <DateTimePicker
                    value={moment(discountData.valid_from).toDate()}
                    onChange={this.handleStartTimeChange}
                    okLabel={"完了"}
                    cancelLabel={"キャンセル"}
                  />

                  <span>~</span>

                  <DateTimePicker
                    value={moment(discountData.valid_to).toDate()}
                    shouldDisableDate={this.disabledEndTime}
                    onChange={this.handleEndTimeChange}
                    okLabel={"完了"}
                    cancelLabel={"キャンセル"}
                  />
                </MuiPickersUtilsProvider>
              </div>
              {errorMessages.find((item) => item.name === "valid_to") && (
                <p className="error-text">
                  {
                    errorMessages.find((item) => item.name === "valid_to")
                      .message
                  }
                </p>
              )}
            </div>
          )}
        </div>
        <div className="booking-form__btns">
          {/* <span
            type="button"
            className="cancel-button me-2"
            disabled={this.state.isBtnDisabled}
            onClick={() => onCloseRequest({})}
          >
            キャンセル
          </span> */}
          <MyButton
            className="me-3"
            myVariant="cancel"
            disabled={this.state.isBtnDisabled}
            onClick={() => onCloseRequest({})}
          >
            キャンセル
          </MyButton>

          <MyButton
            myVariant="create"
            isLoading={this.state.isBtnDisabled}
            onClick={editMenu}
          >
            確定
          </MyButton>
          {/* <span
            type="button"
            disabled={this.state.isBtnDisabled}
            className="add-button me-2"
            onClick={editMenu}
          >
            確定
          </span> */}
        </div>
      </Dialog>
    );
  }
}

export default DiscountDialog;
